import React from "react";
import {
  Container,
  Grid,
  Segment,
  Header,
  Icon,
  Card,
  Button,
} from "semantic-ui-react";
import { useNavigate } from "react-router-dom";

const Backoffice = () => {
  const navigate = useNavigate();

  const opciones = [
    {
      titulo: "Empresas",
      descripcion: "Registra, actualiza y administra empresas clientes.",
      icono: "building outline",
      color: "#2563eb",
      bg: "#eff6ff",
      ruta: "/backofice/agregarempresa",
    },
    {
      titulo: "Estado Tenant",
      descripcion: "Revisa salud operacional de cada empresa.",
      icono: "server",
      color: "#0f766e",
      bg: "#f0fdfa",
      ruta: "/backofice/estado-tenant",
    },
    {
      titulo: "Contrato Mantención",
      descripcion: "Administra Reglas de servicio técnico.",
      icono: "wrench",
      color: "#0f766e",
      bg: "#f0fdfa",
      ruta: "/backofice/contrato-mantencion",
    }/* ,
    {
      titulo: "Planes y Límites",
      descripcion: "Configura planes, módulos activos y límites por empresa.",
      icono: "credit card outline",
      color: "#7c3aed",
      bg: "#f5f3ff",
      ruta: "/backoffice/planes",
    },
    {
      titulo: "Módulos SaaS",
      descripcion: "Activa o desactiva funcionalidades por cliente.",
      icono: "grid layout",
      color: "#0891b2",
      bg: "#ecfeff",
      ruta: "/backoffice/modulos",
    },
    {
      titulo: "Auditoría Global",
      descripcion: "Revisa actividad, cambios críticos y eventos del sistema.",
      icono: "history",
      color: "#ea580c",
      bg: "#fff7ed",
      ruta: "/backoffice/auditoria",
    }, */
  ];

  return (
    <Container fluid style={{ padding: "25px" }}>
      <Segment
        raised
        style={{
          borderRadius: 20,
          padding: "35px",
          minHeight: "82vh",
          border: "1px solid #e5e7eb",
          boxShadow: "0 12px 35px rgba(0,0,0,0.06)",
          background: "linear-gradient(to bottom right, #ffffff, #f8fafc)",
        }}
      >
        <Grid stackable verticalAlign="middle">
          <Grid.Row columns={2}>
            <Grid.Column width={10}>
              <div style={{ marginBottom: 12 }}>
                <span
                  style={{
                    color: "#7c3aed",
                    fontWeight: 700,
                    fontSize: 14,
                    letterSpacing: 1,
                    textTransform: "uppercase",
                  }}
                >
                  BACKOFFICE
                </span>
              </div>

              <Header
                as="h1"
                style={{
                  fontSize: "3rem",
                  marginBottom: 10,
                  color: "#111827",
                }}
              >
                Administración SaaS
              </Header>

              <p
                style={{
                  fontSize: 18,
                  color: "#6b7280",
                  maxWidth: 700,
                  lineHeight: 1.7,
                }}
              >
                Administra empresas, planes, módulos y parámetros globales de
                LogisticMed.
              </p>

              <div
                style={{
                  width: 80,
                  height: 4,
                  background: "#7c3aed",
                  borderRadius: 20,
                  marginTop: 25,
                }}
              />
            </Grid.Column>

            <Grid.Column width={6} textAlign="center" only="computer tablet">
              <div style={{ position: "relative" }}>
                <div
                  style={{
                    width: 260,
                    height: 260,
                    margin: "0 auto",
                    borderRadius: "50%",
                    background:
                      "radial-gradient(circle, rgba(124,58,237,0.15) 0%, rgba(255,255,255,0) 70%)",
                    position: "absolute",
                    left: "50%",
                    top: "50%",
                    transform: "translate(-50%, -50%)",
                  }}
                />

                <Icon
                  name="shield alternate"
                  size="massive"
                  style={{
                    color: "#7c3aed",
                    opacity: 0.85,
                  }}
                />
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Grid stackable columns={4} style={{ marginTop: 30 }}>
          {opciones.map((item, index) => (
            <Grid.Column key={index}>
              <Card
                fluid
                style={{
                  borderRadius: 18,
                  border: "1px solid #eef2f7",
                  boxShadow: "0 8px 25px rgba(15,23,42,0.05)",
                  minHeight: 240,
                }}
              >
                <Card.Content
                  style={{
                    padding: 24,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <div
                      style={{
                        width: 70,
                        height: 70,
                        borderRadius: 18,
                        background: item.bg,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: 20,
                      }}
                    >
                      <Icon
                        name={item.icono}
                        size="big"
                        style={{
                          color: item.color,
                          margin: 0,
                        }}
                      />
                    </div>

                    <Header
                      as="h3"
                      style={{
                        fontSize: 22,
                        color: "#111827",
                        marginBottom: 10,
                      }}
                    >
                      {item.titulo}
                    </Header>

                    <p
                      style={{
                        color: "#6b7280",
                        lineHeight: 1.7,
                        fontSize: 15,
                      }}
                    >
                      {item.descripcion}
                    </p>
                  </div>

                  <div style={{ marginTop: 25 }}>
                    <Button
                      fluid
                      onClick={() => navigate(item.ruta)}
                      style={{
                        borderRadius: 10,
                        background: item.color,
                        color: "#fff",
                        fontWeight: 600,
                      }}
                    >
                      Administrar
                      <Icon name="arrow right" style={{ marginLeft: 8 }} />
                    </Button>
                  </div>
                </Card.Content>
              </Card>
            </Grid.Column>
          ))}
        </Grid>

        <Segment
          style={{
            marginTop: 35,
            borderRadius: 18,
            border: "none",
            background: "linear-gradient(to right, #f5f3ff, #f8fafc)",
            padding: "20px 25px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
            <div
              style={{
                width: 55,
                height: 55,
                borderRadius: 14,
                background: "#ede9fe",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon name="lock" style={{ color: "#7c3aed" }} size="large" />
            </div>

            <div>
              <div
                style={{
                  fontWeight: 700,
                  color: "#5b21b6",
                  marginBottom: 5,
                  fontSize: 16,
                }}
              >
                Administración restringida
              </div>

              <div style={{ color: "#64748b", fontSize: 14 }}>
                Esta sección está pensada solo para administradores globales del
                SaaS.
              </div>
            </div>
          </div>
        </Segment>
      </Segment>
      
    </Container>
  );
};

export default Backoffice;